// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 1440 180%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath fill=%27%2300B4D8%27 fill-opacity=%270.5%27 d=%27M0,120 Q180,60 360,120 T720,120 T1080,120 T1440,120 V180 H0 Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 1440 180%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath fill=%27%2300B4D8%27 fill-opacity=%270.5%27 d=%27M0,130 Q180,180 360,130 T720,130 T1080,130 T1440,130 V180 H0 Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add this to your existing waves.css or a global stylesheet */

.star {
  position: absolute;
  width: 2px;
  height: 2px;
  background: white;
  border-radius: 50%;
  opacity: 0.8;
  animation: twinkle 2s infinite ease-in-out alternate;
}

@keyframes twinkle {
  0% {
    transform: scale(1);
    opacity: 0.3;
  }
  100% {
    transform: scale(1.5);
    opacity: 1;
  }
}

.animated-waves {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(0, 180, 216, 0.2), transparent);
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}

.animated-waves::before,
.animated-waves::after {
  content: "";
  position: absolute;
  width: 200%;
  height: 180px;
  bottom: 0;
  left: 0;
  background-repeat: repeat-x;
  background-size: auto 100%;
  transform: translateY(0); /* static surface */
}

.animated-waves::before {
  opacity: 0.5;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  animation: waveMove 10s linear infinite;
}

.animated-waves::after {
  opacity: 0.3;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  animation: waveMove 15s linear infinite;
  animation-delay: 0s;
}

@keyframes waveMove {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/waves.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,oDAAoD;AACtD;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2EAA2E;EAC3E,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,SAAS;EACT,OAAO;EACP,2BAA2B;EAC3B,0BAA0B;EAC1B,wBAAwB,EAAE,mBAAmB;AAC/C;;AAEA;EACE,YAAY;EACZ,yDAA0O;EAC1O,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,yDAA2O;EAC3O,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["/* Add this to your existing waves.css or a global stylesheet */\r\n\r\n.star {\r\n  position: absolute;\r\n  width: 2px;\r\n  height: 2px;\r\n  background: white;\r\n  border-radius: 50%;\r\n  opacity: 0.8;\r\n  animation: twinkle 2s infinite ease-in-out alternate;\r\n}\r\n\r\n@keyframes twinkle {\r\n  0% {\r\n    transform: scale(1);\r\n    opacity: 0.3;\r\n  }\r\n  100% {\r\n    transform: scale(1.5);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.animated-waves {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(to bottom, rgba(0, 180, 216, 0.2), transparent);\r\n  overflow: hidden;\r\n  pointer-events: none;\r\n  z-index: -1;\r\n}\r\n\r\n.animated-waves::before,\r\n.animated-waves::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 200%;\r\n  height: 180px;\r\n  bottom: 0;\r\n  left: 0;\r\n  background-repeat: repeat-x;\r\n  background-size: auto 100%;\r\n  transform: translateY(0); /* static surface */\r\n}\r\n\r\n.animated-waves::before {\r\n  opacity: 0.5;\r\n  background-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 1440 180' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%2300B4D8' fill-opacity='0.5' d='M0,120 Q180,60 360,120 T720,120 T1080,120 T1440,120 V180 H0 Z'/%3E%3C/svg%3E\");\r\n  animation: waveMove 10s linear infinite;\r\n}\r\n\r\n.animated-waves::after {\r\n  opacity: 0.3;\r\n  background-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 1440 180' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%2300B4D8' fill-opacity='0.5' d='M0,130 Q180,180 360,130 T720,130 T1080,130 T1440,130 V180 H0 Z'/%3E%3C/svg%3E\");\r\n  animation: waveMove 15s linear infinite;\r\n  animation-delay: 0s;\r\n}\r\n\r\n@keyframes waveMove {\r\n  from {\r\n    transform: translateX(0);\r\n  }\r\n  to {\r\n    transform: translateX(-50%);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
